import {Component} from '@angular/core';

@Component({
  selector: 'spinner',
  imports: [],
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
})
export class SpinnerComponent {
}
